<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_3"></h2>
<p class="small"><em class="i">InterVarsity Press<br/>
  P.O. Box 1400,<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web:</em> <a href="http://www.ivpress.com" target="_blank"><span class="hyperlinks">www.ivpress.com</span></a><br/>
<em class="i">Email:</em> <a href="mailto:email%40ivpress.com?subject="><span class="hyperlinks">email@ivpress.com</span></a></p>
<p class="small"><em class="i">©2013 by MaryKate Morse</em></p>
<p class="small"><em class="i">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</em></p>
<p class="small"><em class="i">InterVarsity Press</em><em class="i">®</em> <em class="i">is the book-publishing division of InterVarsity Christian Fellowship/USA</em><em class="i">®</em><em class="i">, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at</em> <a href="http://www.intervarsity.org" target="_blank"><span class="hyperlinks">www.intervarsity.org</span></a><em class="i">.</em></p>
<p class="small"><em class="i">Scripture quotations, unless otherwise noted, are from the New Revised Standard Version of the Bible, copyright 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.</em></p>
<p class="small"><em class="i">While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.</em></p>
<p class="small"><em class="i">The closing chapter is adapted from “The Problem of Prayerlessness” by MaryKate Morse in</em> <em class="i">Giving Ourselves to Prayer,</em> <em class="i">© 2007 PrayerShop Publishing. Used with permission.</em></p>
<p class="small"><em class="i">Cover Design: Cindy Kiple</em></p>
<p class="small"><em class="i">Images: sheep at sunset: Peter Adams/Getty Images sailboat in storm: o-che/Getty Images</em></p>
<p class="small"><em class="i">ISBN 978-0-8308-3578-2 (print)<br/>
  ISBN 978-0-8308-6464-5 (digital)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3c33001d